import { useRef, useEffect } from 'react'

function useDocumentTitle(title, hideCompany = false, prevailOnUnmount = false) {
  const defaultTitle = useRef(document.title);
  const company = 'Pamova Tutor App'

  useEffect(() => {
	if (!hideCompany) {
		title = `${title} | ${company}`
	}
    document.title = title;
  }, [title]);

  useEffect(() => () => {
    if (!prevailOnUnmount) {
      document.title = defaultTitle.current;
    }
  }, [])
}

export default useDocumentTitle